import { format } from "date-fns";
import { HeroCardProps } from "../types";
import wind from "../../../assets/images/highlights/air.svg";
import rain from "../../../assets/images/highlights/rain.svg";
import { WeatherIcon } from "../../../utils/commons/getWeatherIcon";
import { useLanguage } from "../../../components/contexts/LanguageContext";
import translations from "../../../components/translations";
import { useGetData } from "../../../hooks/getData/useGetData";
import { useEffect, useState } from "react";
import { useParams } from "../../../hooks/common/useParams";
import { ClimateDataType } from "../../../types/climateData/ClimateDataTypes";
import { Weather } from "../../../types/variables/Variables";
import Skeleton from "@mui/material/Skeleton";
import { useGetOUWeather } from "../../../hooks/getSelectedOuWeather/useGetSelectedOuWeather";

const HeroCard = () => {
  const { useUrlParamiters } = useParams();
  const { selectedLanguage } = useLanguage();
  const { orgUnitName } = useUrlParamiters();
  const { data, loading } = useGetOUWeather()

  return (
    <div className="col-xl-4 col-lg-6">
      <div className="detail">
        <div className="mb-24 city-detail">
          <div className="d-flex align-items-center column-gap-1 mb-8">
            <h4 className="fs-28 fw-6 color-dark m-0">
              {loading ? <Skeleton width={"301px"} height={"67px"} /> : data?.organisationUnit ?? orgUnitName}
            </h4>
          </div>

          <h6 className="fs-16 fw-4 color-dark">
            {loading ? <Skeleton width={"140px"} height={"25px"} sx={{ p: "0 0 20px" }} /> : format(new Date(), "dd MMMM yyyy")}
          </h6>
        </div>

        {
          !loading && Object.keys(data ?? {}).length === 0 ?
            <div className="weather-detail"> {translations[selectedLanguage].noData}</div>
            :
            <>
              <div className="weather-detail d-flex align-items-center justify-content-between mb-32">
                <div>
                  <h2 className="fw-4 fs-95 lh-100 color-dark m-0">
                    {loading ? (
                      <Skeleton width={"140px"} height={"150px"} />
                    ) : (
                      <>
                        {data?.maxAirTemperature ? `${data?.maxAirTemperature}°` : "--"}
                      </>
                    )}
                  </h2>
                </div>

                {loading ? (
                  <Skeleton width={"140px"} height={"150px"} />
                ) : (
                  <WeatherIcon weather={data?.weatherIcon as unknown as Weather} />
                )}
              </div>
              <div className="indicator-detail d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center justify-content-center">
                  {loading ? (
                    <Skeleton width={140} height={35} />
                  ) : (
                    <>
                      <img src={rain} />
                      <h6 className="fs-14 fw-6 color-dark mb-0">
                        {translations[selectedLanguage].precipitation}:{" "}
                        {data?.precipitation ? `${data?.precipitation}mm` : "--"}
                      </h6>
                    </>
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  {loading ? (
                    <Skeleton width={140} height={35} />
                  ) : (
                    <>
                      <img src={wind} />
                      <h6 className="fs-14 fw-6 color-dark mb-0">
                        {translations[selectedLanguage].wind}:{" "}
                        {data?.wind ? `${data?.wind}km/h` : "--"}
                      </h6>
                    </>
                  )}
                </div>
              </div>
            </>
        }
      </div>
    </div >
  );
};

export { HeroCard };